'use client';

interface LogoProps {
  initials?: string;
  size?: 'small' | 'medium' | 'large' | number;
  className?: string;
}

export default function Logo({ 
  initials = 'FP', 
  size = 'medium',
  className = '' 
}: LogoProps) {
  // Determine size
  const sizeMap = {
    small: 32,
    medium: 48,
    large: 64,
  };
  const iconSize = typeof size === 'number' ? size : sizeMap[size];

  return (
    <svg 
      className={className}
      width={iconSize} 
      height={iconSize} 
      viewBox="0 0 64 64" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Shopping basket */}
      <path 
        d="M12 24 L52 24 L50 48 L14 48 Z" 
        fill="#105c38" 
        stroke="#0d4a2d" 
        strokeWidth="2" 
        strokeLinejoin="round"
      />
      {/* Basket handle */}
      <path 
        d="M20 24 C20 18 24 14 32 14 C40 14 44 18 44 24" 
        stroke="#105c38" 
        strokeWidth="2.5" 
        fill="none" 
        strokeLinecap="round"
      />
      {/* Client initials in white, centered vertically */}
      <text 
        x="32" 
        y="36" 
        fontFamily="'Dancing Script', cursive" 
        fontSize="22" 
        fontWeight="700" 
        fill="white" 
        textAnchor="middle" 
        dominantBaseline="central"
      >
        {initials}
      </text>
    </svg>
  );
}

